import React, { useState } from "react";
import '../ResourceStyle.css'
import StepTabs from "../../../../../Components/Stepbar/Steptabs";
import UploadFAQ from "./UploadFAQTab";
import UploadDocuments from "./UploadDocumentsTab";

const UploadSupportInfo = () =>{
    const tabNames = ["Upload FAQ's", "Upload Documents"];
    return (
    <div className="main-tab">
        <div className="tabs-upload">
        <StepTabs size={"large "} tabNames={tabNames}>
            <UploadFAQ/>
            <UploadDocuments/>
       </StepTabs>
        </div>
    </div>
    )
}
export default UploadSupportInfo